import RequestBase from '../Resources/RequestBase';

export class SignContractRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/Contracts';
        this.method = 'POST';
        this.test = true;
        this.success = success;
        this.error = 'Wrong parameters';
        this.data = { data: {} };
    }
}

export class GenerateContractRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/Contracts/{customerId}?type={contractTypeId}';
        this.method = 'GET';
        this.test = true;
        this.success = success;
        this.error = 'Wrong parameters';
        this.data = {
            data: {
                document: 'There should be a document here.'
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/TestResources/Contracts.js